import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import api from "../api/Api";

const ChamadasExcel = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(null);
  

  useEffect(() => {
    const gerarExcelAutomaticamente = async () => {
      try {
        setLoading(true);
        setErro(null);

        const searchParams = new URLSearchParams(location.search);
        const dataInicio = searchParams.get("dataInicio");
        const dataFim = searchParams.get("dataFim");
        const statusFiltro = searchParams.get("statusFiltro");
        const tiposSelecionadosParam = searchParams.get("tiposSelecionados");
        const filasSelecionadasParam = searchParams.get("filasSelecionadas");
        const operadorFiltro = searchParams.get("operadorFiltro");
        


        let datas = [dayjs().startOf("month"), dayjs().endOf("month")];

        if (dataInicio && dataFim) {
          datas = [dayjs(dataInicio), dayjs(dataFim)];
        }

        const payload = {
          dataInicio: datas[0].format("YYYY-MM-DD"),
          dataFim: datas[1].format("YYYY-MM-DD"),
        };

        const [chamadasResponse, dashboardResponse] = await Promise.all([
          api.ListChamada(payload),
          api.ListDashboard(payload),
        ]);

        let chamadasData = Array.isArray(chamadasResponse)
          ? chamadasResponse
          : [];
        let dashboardData =
          dashboardResponse && typeof dashboardResponse === "object"
            ? dashboardResponse
            : {};

    const chamadasFiltradas = aplicarFiltros(chamadasData, statusFiltro, filasSelecionadasParam, operadorFiltro);


  await gerarExcel(
  chamadasFiltradas,
  dashboardData,
  datas,
  statusFiltro,
  tiposSelecionadosParam,
  filasSelecionadasParam,
  operadorFiltro 
);



        setTimeout(() => window.close(), 1000);
      } catch (error) {
        console.error("Erro ao gerar Excel:", error);
        setErro("Erro ao gerar o relatório Excel. Feche esta janela e tente novamente.");
      } finally {
        setLoading(false);
      }
    };

    gerarExcelAutomaticamente();
  }, [location]);

const aplicarFiltros = (chamadasData, statusFiltro, filaFiltro, operadorFiltro) => {
  let chamadasFiltradas = [...chamadasData];

  // Filtrar por status
  if (statusFiltro) {
    chamadasFiltradas = chamadasFiltradas.filter(
      (chamada) => chamada.status === statusFiltro
    );
  }

  // Filtrar por fila
  if (filaFiltro) {
    chamadasFiltradas = chamadasFiltradas.filter(
      (chamada) => chamada.fila === filaFiltro
    );
  }

  // ✅ Filtrar por operador
  if (operadorFiltro) {
    chamadasFiltradas = chamadasFiltradas.filter(
      (chamada) => chamada.agente === operadorFiltro
    );
  }

  return chamadasFiltradas;
};




  const gerarExcel = (  chamadasFiltradas,
  dashboardData,
  datas,
  statusFiltro,
  tiposSelecionadosParam,
  filasSelecionadasParam,
 operadorFiltro) => {
  return new Promise((resolve) => {
    // ---- Cabeçalho geral ----
    const linhas = [
      ["RELATÓRIO DE CHAMADAS"],
      [`Período: ${datas[0].format("DD/MM/YYYY")} - ${datas[1].format("DD/MM/YYYY")}`],
      [`Data de geração: ${dayjs().format("DD/MM/YYYY HH:mm")}`],
[
  `Filtros aplicados: ${
    statusFiltro ? `Status: ${statusFiltro}` : "Todos os status"
  }${
    filasSelecionadasParam ? ` | Fila: ${filasSelecionadasParam}` : ""
  }${
    operadorFiltro ? ` | Operador: ${operadorFiltro}` : ""
  }${
    tiposSelecionadosParam ? ` | Tipo: ${tiposSelecionadosParam}` : ""
  }`,
],


      [], // Linha em branco
      ["RESUMO ESTATÍSTICO"],
      ["Indicador", "Quantidade"],
      ["Total de chamadas", dashboardData.todas || 0],
      ["Atendidas", dashboardData.atendidas || 0],
      ["Não atendidas", dashboardData.n_atendidas || 0],
      ["Abandonadas", dashboardData.abandonadas || 0],
      ["Chamadas filtradas", chamadasFiltradas.length],
      [], // Linha em branco
      ["DETALHES DAS CHAMADAS"],
      // 👉 Aqui adicionamos a coluna "Fila"
      ["Data", "Hora", "Contacto", "Fila", "Tempo de Espera", "Duração", "Status", "Operador"],
    ];

    // ---- Adicionar corpo da tabela ----
    const detalhesBody = chamadasFiltradas.map((chamada) => [
      dayjs(chamada.data).format("DD/MM/YYYY"),
      dayjs(chamada.data).format("HH:mm"),
      chamada.contacto || "N/A",
      chamada.fila || "N/A", // 👉 Campo da fila adicionado
      chamada.espera || "N/A",
      chamada.duracao || "N/A",
      chamada.status || "N/A",
      chamada.agente || "N/A",
    ]);

    const dadosCompletos = [...linhas, ...detalhesBody];

    // ---- Criar worksheet e workbook ----
    const ws = XLSX.utils.aoa_to_sheet(dadosCompletos);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Relatório de Chamadas");

    // ---- Gerar e baixar o arquivo ----
    const fileName = `relatorio_chamadas_${dayjs().format("YYYY-MM-DD_HH-mm")}.xlsx`;
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName);

    resolve();
  });
};



  if (loading) {
    return (
      <div
        style={{
          padding: "24px",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #f5f7fa 0%, #e4efe9 100%)",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h3>Gerando Excel...</h3>
        </div>
      </div>
    );
  }

  if (erro) {
    return (
      <div
        style={{
          padding: "24px",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #f5f7fa 0%, #e4efe9 100%)",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h3 style={{ color: "#ff4d4f" }}>Erro ao gerar Excel</h3>
          <p>{erro}</p>
          <button
            onClick={() => window.close()}
            style={{
              padding: "8px 16px",
              backgroundColor: "#1890ff",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Fechar Janela
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default ChamadasExcel;
